<template>
  <div>
    <vx-card
      v-can="'view-supplier-users'"
      titleIcon="FilterIcon"
      ref="filterCard"
      title="Advanced Filters"
      class="user-list-filters mb-8"
      :collapse-action="true"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Supplier Name</label>

          <vs-input
            type="search"
            placeholder="Search.."
            v-model="filters['company_name']"
            class="mb-4 md:mb-0 w-full"
          />
        </div>
      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button
            class="float-right mr-4"
            size="small"
            color="danger"
            type="border"
            icon-pack="feather"
            v-on:click="filters = {}"
            >CLEAR</vs-button
          >
        </div>
      </div>
    </vx-card>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="SUPPLIER USERS">
          <template slot="actions" v-can="'create-edit-supplier-users'">
            <vs-button
              @click="openCreateUserPopUp"
              class="mr-4"
              color="primary"
              type="filled"
              >Create Supplier User</vs-button
            >
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table
              pagination
              max-items="10"
              :data="userList"
              @sort="handleSort"
              stripe
              class="table-dark-inverted table-auto vs-con-loading__container"
            >
              <template slot="thead">
                <vs-th>SUPPLIER USER NAME</vs-th>
                <vs-th>EMAIL</vs-th>
                <vs-th>NIMBLE USER ROLES</vs-th>
                <!-- <vs-th>SUPPLIER PORTAL ROLE</vs-th>
                <vs-th class="float-left">PORTAL STATUS</vs-th> -->
                <vs-th v-can="'create-edit-supplier-users'">ACTION</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr
                  class="cursor-pointer"
                  :key="indextr"
                  v-for="(tr, indextr) in data"
                >
                  <vs-td :data="data[indextr].first_name">
                    {{ data[indextr].title }} {{ data[indextr].first_name }}
                    {{ data[indextr].last_name }}
                  </vs-td>
                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>
                  <vs-td :data="data[indextr].types">
                    <span
                      v-for="(type, index) in data[indextr].types"
                      :key="index"
                    >
                      {{ type.name }},
                    </span>
                  </vs-td>
                  <!-- <vs-td :data="data[indextr].role">
                    {{ data[indextr].role ? data[indextr].role.name : "" }}
                  </vs-td>
                  <vs-td :data="data[indextr].is_active">
                    <vs-chip
                      transparent
                      v-if="data[indextr].is_active"
                      color="primary"
                    >
                      activated
                    </vs-chip>
                    <vs-chip
                      transparent
                      v-if="!data[indextr].is_active"
                      color="danger"
                    >
                      de-activated
                    </vs-chip>
                  </vs-td> -->
                  <vs-td v-can="'create-edit-supplier-users'">
                    <div class="vx-row">
                      <vx-tooltip text="View" position="left">
                        <vs-button
                          class="ml-3"
                          @click.stop="openViewUserPopUp(data[indextr])"
                          size="small"
                          color="primary"
                          type="border"
                          icon-pack="feather"
                          icon="icon-eye"
                        ></vs-button>
                      </vx-tooltip>
                      <vx-tooltip
                        v-if="!data[indextr].is_active"
                        text="Activate user"
                        position="left"
                      >
                        <vs-button
                          class="ml-3"
                          @click.stop="
                            onClickChangeSupplierStatus(
                              data[indextr].id,
                              'activate'
                            )
                          "
                          size="small"
                          color="primary"
                          type="border"
                          icon-pack="feather"
                          icon="icon-check"
                        ></vs-button>
                      </vx-tooltip>
                      <vx-tooltip
                        v-if="data[indextr].is_active"
                        text="De-activate user"
                        position="left"
                      >
                        <vs-button
                          class="ml-3"
                          @click.stop="
                            onClickChangeSupplierStatus(
                              data[indextr].id,
                              'de-activate'
                            )
                          "
                          size="small"
                          color="danger"
                          type="border"
                          icon-pack="feather"
                          icon="icon-x"
                        ></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
    <CreateOtherSupplierUserPopUp ref="createOtherSupplierUserPopUp" />
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import CreateOtherSupplierUserPopUp from "@/components/popups/other-suppliers/users/CreateOtherSupplierUserPopUp.vue";
const OtherSupplierRepository = RepositoryFactory.get("other_supplier");

export default {
  name: "supplierUsersList",
  data() {
    return {
      filters: {},
      userList: [],
      supplierId: null,
    };
  },
  async mounted() {
    await this.getList();
  },
  components: {
    CreateOtherSupplierUserPopUp,
  },
  methods: {
    async refreshData() {
      await this.getList();
    },
    async getList() {
      try {
        this.$vs.loading();
        this.supplierId = this.$route.params.id;
        const { data } = (
          await OtherSupplierRepository.getOtherSupplierUserList(
            this.supplierId
          )
        ).data;
        this.userList = data;

        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    openCreateUserPopUp() {
      this.$refs.createOtherSupplierUserPopUp.openPopup();
    },
    openViewUserPopUp(data) {
      this.$refs.createOtherSupplierUserPopUp.openPopup(data);
    },
    async onClickChangeSupplierStatus(id, status) {
      try {
        this.$vs.loading();
        await OtherSupplierRepository.changeOtherSupplierUserStatus(id, status);
        await this.refreshData();
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
